// @format
import { connect } from 'react-redux';
import F from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '@sonyged/ext-proc';

import { themeOf } from './utils';
import AppContext from '../../AppContext';

class WelcomePage extends React.Component {
  static contextType = AppContext;

  componentDidMount() {
    this.context.soundController.bgmStop();

    const playPromise = this.video.play();
    if (playPromise) {
      playPromise.catch(() => {
        // Automatic playback failed
        // Do nothing
      });
    }

    this.video.addEventListener(
      'ended',
      () => {
        this.onNext();
      },
      false
    );
  }

  render() {
    return (
      <div className={`proc-video proc-root ${themeOf(this.props.kind)}`}>
        <div className={'proc-background tertiary100-bg-color'}>
          <div className={'proc-outer'}>
            <div className={'proc-inner flex flex-column'}>
              <div className={'proc-contents'}>
                <video
                  ref={(r) => {
                    this.video = r;
                  }}
                  preload="auto"
                  muted={Boolean(this.props.muted)}
                  className={'w100'}
                  playsInline={true}
                  src={this.props.videoUrl}
                />
              </div>
              <Button.light onClick={this.onNext.bind(this)}>スキップ</Button.light>
            </div>
          </div>
        </div>
      </div>
    );
  }

  onNext() {
    this.props.history.replace(`/${this.props.kind}`);
  }
}

WelcomePage.propTypes = {
  kind: PropTypes.string,
  videoUrl: PropTypes.string,
  history: PropTypes.object,
  muted: PropTypes.bool,
};

WelcomePage.defaultProps = {
  kind: 'ice',
};

const mapStateToProps = (state, { match: { params } }) => {
  const contestType = params.contestType;
  const avatar = F.get('profile.avatar', state);
  return {
    muted: state.config.mute,
    kind: contestType,
    videoUrl: `/videos/${contestType}_welcome_${avatar}.mp4`,
  };
};

export default connect(mapStateToProps)(WelcomePage);
